// @generated by TypeGen from LogbookModel/Session.swift - DO NOT EDIT

import type { IAccount } from "./Account"
import type { IAccountUserLevel } from "./AccountUser"
import type { IUser } from "./User"

export interface ILogbookSession {
  id?: string;
  accountId?: number;
  authorized: boolean;
  shipId?: number;
  userId?: number;
}

export interface ISessionResponse {
  account?: IAccount;
  session: ILogbookSession;
  type: ILogbookSessionType;
  user?: IUser;
  server?: string;
  features?: string[];
  accountUserLevel?: IAccountUserLevel;
  version?: string;
}

export enum ILogbookSessionClient {
  app = "app",
  cloud = "cloud",
}

export enum ILogbookSessionType {
  cloud = "cloud",
  primary = "primary",
  local = "local",
}
